import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import { zoneGamesPlaceholder } from '../../constants/placeholder';
import TextBubbles from '@home/components/TextBubbles';


export default function ZoneGameSelect({
  onChange,
  defaultKey,
  defaultValue,
  filterValue,
  filterOptions,
  lang,
}: SingleCommonType) {

  const gameOptions = useMemo(() => {
    console.log("filterOptions :: ", filterOptions)
    return (filterOptions || []).map((item: any) => ({
      text: item.game_name,
      icon: item.cover,
      value: item.game_id,
    }));
  }, [filterOptions]);

  const {
    selects: value,
    setSelects: setValue,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'zone_games',
    options: gameOptions.map((item: any) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'zone_games',
      commonBackInfo(
        { zone_games: value },
        { [defaultKey]: text },
        { needChangeEntity: false, isAll },
      ),
    );
  }, [value]);

  return (
    <div className={`dbo-zone-game-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={zoneGamesPlaceholder[lang] || 'Games'}
        onClear={() => setValue([])}
        selectOptionsInfo={[value, setValue]}
        options={gameOptions}
        pointKey={FilterButtonPoint.zoneGames}
        matchButtonWidth={false}
        boxClassName="dbo-zone-game-list-select"
        optionItemRender={(text: string, _value: any, item: any) => {
          return (
            <div className="dbo-zone-game-list-select-item">
              <RenderGameIcon
                className="game-icon"
                gameInfo={{ cover: item.icon }}
              />
              <TextBubbles text={text} />
            </div>
          );
        }}
      />
    </div>
  );
}
